/**
 * Domain-layer input/length limits that encode Flutter business-parity
 * thresholds (as opposed to the presentation-layer
 * `presentation/constants/formatters/inputLengthFormatters.ts`, which collects
 * UI text-field length limits). Kept in the domain layer because these values
 * are consumed by domain-layer pure functions that implement Flutter business
 * rules.
 */
export const InputLengthFormatters = {
  /**
   * Max length of a community reply-preview snippet before it is truncated with
   * a trailing "...". Parity with Flutter
   * `AppConstants.communityMessageReplyTextMaxLength = 80` (app_constants.dart:16).
   * Strict `<` (community_screen.dart:482). Under 80 chars: the full text with
   * no ellipsis. At exactly 80 the substring keeps all 80 chars but a trailing
   * "..." is still appended; only a text strictly longer than 80 has characters
   * removed.
   */
  communityReplyPreviewMaxLength: 80,
} as const;

export type InputLengthFormatters = typeof InputLengthFormatters;
